import axios from 'axios'
import { addProduct } from './cart'
import { getFormattedMoneyString, removeTrailingZeros } from './globale'

let productJson
let hasComingSoonTag
let hasWaitlistTag
let specialTags
let promoTags
let mainBadgeTag

const selectors = {
  featuredSlider: '.js-featuredSlider',
  thumbnailSlider: '.js-thumbnailsSlider',
  swiperWrapper: '.swiper-wrapper',
  galleryContainer: '.js-gallery-refresh',
  gridContainer: '.ProductImageFormGrid',
  descriptionContainer: '.ProductDescription',
  crossSells: '.js-cross-sell-wrapper',
  mediaGrid: '.js-media-grid',
  formSubmit: '.js-productFormSubmit',
  price: '.js-price .currency-formatting',
  comparePrice: '.js-compareAtPrice',
  optionContainer: '.js-singleOptionsContainer',
  fixedOptionContainer: '.js-fixedOptionsContainer',
  fixedSingleOptionSelector: '.js-fixedSingleOptionSelector',
  optionText: '.js-selectedOption',
  selectedColor: '.js-color-label',
  fixedSelectedColor: '.js-fixed-color-label',
  fixedOptionBtnColor: '.js-fixedOptionBtnColor',
  variantIdInput: '.js-variantId',
  formActions: '.js-productFormActions',
  wishListButton: '.js-iWishAdd',
  reviewsBtn: '.js-scrollToReviews',
  promoMsgContainer: '.js-promo-message',
  promoMsgHeading: '.js-promo-message-heading',
  promoMsgText: '.js-promo-message-text',
  klarna: 'klarna-placement',
}

/**
 * DOM node selectors.
 */
const nodeSelectors = {
  galleryContainer: document.querySelector(selectors.galleryContainer),
  gridContainer: document.querySelector(selectors.gridContainer),
  descriptionContainer: document.querySelector(selectors.descriptionContainer),
  formSubmitButtons: document.querySelectorAll(selectors.formSubmit),
  price: document.querySelectorAll(selectors.price),
  compareAtPrice: document.querySelectorAll(selectors.comparePrice),
  optionContainer: document.querySelectorAll(selectors.optionContainer),
  fixedOptionContainer: document.querySelectorAll(selectors.fixedOptionContainer),
  fixedSingleOptionSelector: document.querySelectorAll(selectors.fixedSingleOptionSelector),
  optionText: document.querySelectorAll(selectors.optionText),
  fixedSelectedColor: document.querySelector(selectors.fixedSelectedColor),
  selectedColor: document.querySelector(selectors.selectedColor),
  fixedOptionBtnColor: document.querySelectorAll(selectors.fixedOptionBtnColor),
  variantIdInputs: document.querySelectorAll(selectors.variantIdInput),
  formActions: document.querySelector(selectors.formActions),
  wishListButton: document.querySelector(selectors.wishListButton),
  reviewsBtn: document.querySelector(selectors.reviewsBtn),
  promoMsgContainer: document.querySelector(selectors.promoMsgContainer),
  promoMsgHeading: document.querySelector(selectors.promoMsgHeading),
  promoMsgText: document.querySelector(selectors.promoMsgText),
  klarna: document.querySelector(selectors.klarna),
}

const productInfoInit = () => {
  productJson = JSON.parse(document.querySelector('.js-productJson').innerHTML)
  hasComingSoonTag = productJson.tags.findIndex((tag) => tag.toLowerCase() === 'coming soon') > -1
  hasWaitlistTag = productJson.tags.findIndex((tag) => tag.toLowerCase() === 'waitlist') > -1
  mainBadgeTag = productJson.tags.filter((tag) => tag.toLowerCase().includes('badge:'))
  mainBadgeTag = mainBadgeTag[mainBadgeTag.length - 1] ? mainBadgeTag[mainBadgeTag.length - 1].split(':')[1] : null
  // eslint-disable-next-line
  specialTags = productJson.tags.map((tag) => {
    const sanitizedTag = tag.toLowerCase()
    if (sanitizedTag === 'final sale' || sanitizedTag === 'final_sale') {
      return 'Final Sale'
    }

    if (sanitizedTag.includes('madetoorder')) {
      return 'Made To Order'
    }

    if (sanitizedTag.includes('exclusive')) {
      return 'Exclusive'
    }
    // eslint-disable-next-line
    if (sanitizedTag.includes("rebecca's picks")) {
      return 'RM Picks'
    }
  }).filter((tag) => tag)

  specialTags = [...new Set(specialTags)]
  // eslint-disable-next-line
  promoTags = productJson.tags.filter((tag) => {
    const sanitizedTag = tag.toLowerCase()
    if (sanitizedTag.includes('badge_promo:') || sanitizedTag.includes('badge_promo_checkout:')) {
      return tag
    }
  })
}

const buildSpecialTag = (text) => {
  const tag = document.createElement('div')
  tag.classList.add('ProductForm__tag')
  tag.classList.add('js-product-tag')

  if (text === 'Final Sale') {
    tag.classList.add('ProductForm__tag--red')
  }

  tag.innerHTML = `
    <span class="btn-link">
      ${text}
    </span>
  `

  return tag
}

const setScripts = (elm) => {
  Array.from(elm.querySelectorAll('script'))
    .forEach((oldScriptEl) => {
      const newScriptEl = document.createElement('script')

      Array.from(oldScriptEl.attributes).forEach((attr) => {
        newScriptEl.setAttribute(attr.name, attr.value)
      })

      const scriptText = document.createTextNode(oldScriptEl.innerHTML)
      newScriptEl.appendChild(scriptText)

      oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl)
    })
}

const updateMediaGrid = (container, element) => {
  const oldGrid = container.querySelectorAll(selectors.mediaGrid)
  const newGrid = element.querySelectorAll(selectors.mediaGrid)

  oldGrid.forEach((oldItem) => {
    oldItem.remove()
  })

  newGrid.forEach((newItem) => {
    nodeSelectors.gridContainer.append(newItem)
  })
}

const swapElement = (container, element, selector) => {
  const descriptionContainer = container.querySelector(selector)
  const newDescription = element.querySelector(selector)
  descriptionContainer.innerHTML = newDescription.innerHTML
}

const updateGallery = (instance, container, element) => {
  const { dom } = instance
  const featuredContainer = container.querySelector(selectors.featuredSlider)
  const cloneContainer = nodeSelectors.galleryContainer.cloneNode(true)
  cloneContainer.classList.add('cloned')
  const featuredWrapper = featuredContainer.querySelector(selectors.swiperWrapper)
  const newElementContainer = element.querySelector(selectors.featuredSlider)
  const newElementWrapper = newElementContainer.querySelector(selectors.swiperWrapper)
  const images = newElementWrapper.querySelectorAll('img')
  const videos = newElementWrapper.querySelectorAll('video')

  if (images.length > 0) {
    images.forEach((image) => {
      image.src = image.dataset.src
      image.dataset.src = ''
    })
  } else {
    videos.forEach((video) => {
      video.src = video.dataset.src
      video.dataset.src = ''
    })
  }

  const thumbnailContainer = container.querySelector(selectors.thumbnailSlider)
  const thumbnailWrapper = thumbnailContainer.querySelector(selectors.swiperWrapper)

  const newThumbnailContainer = element.querySelector(selectors.thumbnailSlider)
  const newThumbnailWrapper = newThumbnailContainer.querySelector(selectors.swiperWrapper)

  nodeSelectors.gridContainer.prepend(cloneContainer)
  nodeSelectors.galleryContainer.classList.remove('is-active')
  featuredWrapper.remove()
  featuredContainer.append(newElementWrapper)

  thumbnailWrapper.remove()
  thumbnailContainer.append(newThumbnailWrapper)

  window.basis.EventBus.listen('swiper-ready', () => {
    setTimeout(() => {
      cloneContainer.remove()
    }, 100)
  })

  dom.$featuredContainer = featuredContainer
}

const handleSubmitBtnState = (variantAvailable) => {
  if (variantAvailable) {
    nodeSelectors.formSubmitButtons.forEach((button) => {
      button.disabled = false
      button.setAttribute('data-trigger-waitlist', 'false')
    })

    if (nodeSelectors.formActions) {
      nodeSelectors.formActions.classList.remove('variantUnavailable')
    }
  } else {
    if (hasComingSoonTag || hasWaitlistTag) {
      nodeSelectors.formSubmitButtons.forEach((button) => {
        button.setAttribute('data-trigger-waitlist', 'true')
      })
    } else {
      nodeSelectors.formSubmitButtons.forEach((button) => {
        button.disabled = true
      })
    }

    if (nodeSelectors.formActions) {
      nodeSelectors.formActions.classList.add('variantUnavailable')
    }
  }
}

const updateReviews = (productId, selectedProduct) => {
  const { title, featuredImage } = selectedProduct
  nodeSelectors.reviewsBtn.dataset.productId = productId
  const reviewsWidget = nodeSelectors.reviewsBtn.querySelector('.yotpo')
  reviewsWidget.dataset.productId = productId
  reviewsWidget.dataset.name = title
  reviewsWidget.dataset.url = window.location.href
  reviewsWidget.domain = window.theme.strings.store.shopDomain
  reviewsWidget.dataset.breadCrumbs = specialTags.join('')
  reviewsWidget.dataset.imageUrl = featuredImage
  window.yotpo.refreshWidgets()
}

const updatePromoMsg = (selectedProduct) => {
  const { metafields } = selectedProduct
  const { promoMessagingHeading, promoMessagingText } = metafields

  if (promoMessagingHeading || promoMessagingText) {
    nodeSelectors.promoMsgContainer.classList.remove('is-hidden')
    nodeSelectors.promoMsgHeading.innerHTML = promoMessagingHeading
    nodeSelectors.promoMsgText.innerHTML = promoMessagingText
    return
  }

  nodeSelectors.promoMsgContainer.classList.add('is-hidden')
  nodeSelectors.promoMsgHeading.innerHTML = ''
  nodeSelectors.promoMsgText.innerHTML = ''
}

const getPromoTag = () => {
  if (promoTags?.length <= 0) {
    return false
  }

  let promoTag = promoTags[0]
  const promoCheckoutIndex = promoTags.findIndex((tag) => tag.includes('badge_promo_checkout:'))

  if (promoCheckoutIndex > -1) {
    promoTag = promoTags[promoCheckoutIndex]
  }

  return promoTag.split(':')[1]
}

const upatePromoTags = (instance) => {
  const { dom } = instance
  const promoTagContainer = dom.$promoTagContainer
  promoTagContainer.innerHTML = ''
  const promoTag = getPromoTag()
  if (promoTag) {
    const promoHtml = `
      <div class="ProductForm__tag ProductForm__tag--promo js-product-tag-promo">
        <span>
          ${promoTag}
        </span>
      </div>
    `

    promoTagContainer.innerHTML = promoHtml
  }
}

const updateMainTags = (instance) => {
  const { dom, state } = instance
  const container = dom.$featuredContainer
  const mainSliderTag = container.querySelector(`.${state.mainTagClass}`)

  if (mainSliderTag) {
    mainSliderTag.remove()
  }

  if (mainBadgeTag) {
    const tag = document.createElement('div')
    tag.classList.add('Badge')
    tag.classList.add(state.mainTagClass)

    tag.innerHTML = `
      <span class="Badge__text">
        ${mainBadgeTag}
      </span>
    `

    container.prepend(tag)
  }
}

const updateTags = (instance, selectedProduct) => {
  const { dom, state } = instance
  const currentSpecialTags = dom.$appsContainer?.querySelectorAll(`.${state.specialTagClass}`)

  currentSpecialTags.forEach((tag) => {
    tag.remove()
  })

  if (specialTags.length > 0) {
    specialTags.forEach((newTag) => {
      dom.$appsContainer.prepend(buildSpecialTag(newTag))
    })
  }

  if (selectedProduct.notEligible) {
    dom.$notEligible.innerHTML = selectedProduct.notEligibleCopy
  } else {
    dom.$notEligible.innerHTML = ''
  }

  updateMainTags(instance)
  upatePromoTags(instance)
}

const updateWishListState = (productId, variantId) => {
  nodeSelectors.wishListButton.dataset.productId = productId
  nodeSelectors.wishListButton.dataset.currentVariantId = variantId
  window.basis.EventBus.emit('update-wishlist-state')
}

const updatePrice = (variant) => {
  const { price, compare_at_price, compareAtPrice } = variant
  const priceString = getFormattedMoneyString(price)
  const formattedPrice = removeTrailingZeros(priceString)

  nodeSelectors.price.forEach((variantPrice) => {
    variantPrice.textContent = formattedPrice
  })

  // eslint-disable-next-line
  if (compare_at_price > price || compareAtPrice > price) {
    // eslint-disable-next-line
    const compareAtPriceString = getFormattedMoneyString(compare_at_price || compareAtPrice)
    const formattedCompareAtPrice = removeTrailingZeros(compareAtPriceString)
    nodeSelectors.compareAtPrice.forEach((comparePrice) => {
      comparePrice.textContent = formattedCompareAtPrice
    })
  } else {
    nodeSelectors.compareAtPrice.forEach((variantComparePrice) => {
      variantComparePrice.textContent = ''
    })
  }

  if (nodeSelectors.klarna) {
    nodeSelectors.klarna.dataset.purchaseAmount = price
  }
}

const getOptionTextContainer = (elements, optionType) => {
  const optionTextContainer = Array.from(elements).filter((optionText) => {
    return optionText.querySelector(`[data-option-type="${optionType}"]`)
  })

  if (optionTextContainer.length > 0) {
    return optionTextContainer[0].querySelector(`[data-option-type="${optionType}"]`)
  }

  return false
}

const updateSelectedColor = (selectedVariant) => {
  nodeSelectors.fixedSelectedColor.dataset.color = selectedVariant.variantOptions.color.toLowerCase().replace('/', '-')

  const capitalizeText = selectedVariant.variantOptions.color.split('/').map((text) => {
    const lowerCaseText = text.toLowerCase()
    return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1)
  }).join('/')

  const handleText = selectedVariant.variantOptions.color.toLowerCase().replace('/', '-')
  nodeSelectors.selectedColor.innerText = `Color: ${capitalizeText}`

  if (nodeSelectors.fixedOptionBtnColor.length === 0) {
    nodeSelectors.fixedOptionBtnColor = document.querySelectorAll(selectors.fixedOptionBtnColor)
  }
  nodeSelectors.fixedOptionBtnColor.forEach((btn) => {
    if (btn.dataset.optionType === 'color') {
      if (btn.dataset.value === handleText) {
        btn.classList.add('activeOption')
      } else {
        btn.classList.remove('activeOption')
      }
    }
  })
}

const updateSingleVariantSelector = (instance, optionType, optionValue) => {
  const { state } = instance
  const selectedOptionContainerType = state.isFixedForm
    ? nodeSelectors.optionContainer
    : nodeSelectors.fixedOptionContainer

  const selectedOptionContainer = Array.from(selectedOptionContainerType).find((options) => {
    return options.dataset.option === optionType
  })

  const selectedOptions = selectedOptionContainer.querySelectorAll('button')

  selectedOptions.forEach((option) => {
    if (option.dataset.value === optionValue) {
      option.classList.add(state.altSelectedOptionClass)
    } else {
      option.classList.remove(state.altSelectedOptionClass)
    }
  })

  const selectedOptionText = getOptionTextContainer(nodeSelectors.optionText, optionType)
  // eslint-disable-next-line
  const selectedFixedOptionText = getOptionTextContainer(nodeSelectors.fixedSingleOptionSelector, optionType)

  if (selectedOptionText) {
    selectedOptionText.innerText = `${optionType} ${optionValue}`
  }

  if (selectedFixedOptionText) {
    selectedFixedOptionText.innerText = `${optionType} ${optionValue}`
  }

  window.basis.EventBus.emit('setSelectOptions')
}

const setInnerHTML = (instance, elm, html) => {
  const wrapperHTML = document.createElement('div')
  wrapperHTML.innerHTML = html

  const productSection = wrapperHTML.querySelector('#shopify-section-product')
  const copyProductSection = productSection.cloneNode(true)
  productSection.remove()

  const eachElemSections = elm.children
  Array.from(eachElemSections).forEach((el) => {

    if (el.id !== 'shopify-section-product') {
      el.remove()
    }
  })

  updateGallery(instance, elm, copyProductSection)
  swapElement(elm, copyProductSection, selectors.descriptionContainer)
  swapElement(elm, copyProductSection, selectors.crossSells)
  updateMediaGrid(elm, copyProductSection)

  elm.append(wrapperHTML)
  setScripts(elm)
}

const updateSelectedProduct = (instance) => {
  const { state } = instance
  const selectedProduct = state.swatches.find((swatch) => {
    return swatch.colorHandle === state.selectedOptions.color
  })

  const { productId } = selectedProduct

  let selectedVariant = selectedProduct.variants[0]
  if (selectedProduct.variants.length > 1) {
    // eslint-disable-next-line
    const { ['color']: _, ...rest } = state.selectedOptions
    const keyMap = Object.keys(rest)

    selectedVariant = selectedProduct.variants.find((variant) => {
      const matchOption = keyMap.filter((key) => {
        return variant.variantOptions[key] === state.selectedOptions[key]
      })

      return matchOption.length === keyMap.length
    }) || selectedProduct.variants[0]
  }

  const { variantId, variantAvailable } = selectedVariant
  const variantPrice = productJson.variants.find((key) => key.id === variantId)

  nodeSelectors.variantIdInputs.forEach((variantIdInput) => {
    variantIdInput.value = variantId
  })

  handleSubmitBtnState(variantAvailable)
  updateReviews(productId, selectedProduct)
  updateTags(instance, selectedProduct)
  updateWishListState(productId, variantId)
  updateSelectedColor(selectedVariant)
  updatePromoMsg(selectedProduct)
  updatePrice(variantPrice)
}

const variantChange = (instance) => {
  const { state } = instance
  const optionType = state.selectedOptions.size ? 'size' : 'amount'
  const optionValue = state.selectedOptions[optionType]
  const { variants, id } = productJson
  let optionPlace = 'option2'

  if (productJson.options.length === 1) {
    optionPlace = 'option1'
  }

  const variant = variants.find((key) => key[optionPlace] === optionValue)

  nodeSelectors.variantIdInputs.forEach((variantIdInput) => {
    variantIdInput.value = variant.id
  })

  updatePrice(variant)
  updateSingleVariantSelector(instance, optionType, optionValue)
  handleSubmitBtnState(variant.available)
  updateWishListState(id, variant.id)
}

const colorChange = async(url, instance) => {
  try {
    const containerClass = '.js-productPageContainer'
    const container = document.querySelector(containerClass)
    const response = await axios.get(url)
    const page = document.createElement('html')
    const colorChangeEvent = new Event('colorchange')
    const mountCards = new Event('mountproductcards')
    page.innerHTML = response.data
    container.querySelectorAll('[data-component]').forEach((component) => component.removeAttribute('data-mounted'))
    setInnerHTML(instance, container, page.querySelector(containerClass).innerHTML)
    productInfoInit()
    updateSelectedProduct(instance)
    document.dispatchEvent(colorChangeEvent)
    window.basis.EventBus.emit('colorchange-variants', productJson)
    document.dispatchEvent(mountCards)
    window.Shopify.PaymentButton.init()
    window.history.replaceState({}, null, url)
  } catch (error) {
    console.log('Error fetching related color page', error)
  }
}

const triggerBis = (variantId) => {
  const variant = productJson.variants.find(({ id }) => variantId === id)
  const detail = {
    variantId,
    productId: productJson.id,
    productTitle: productJson.title,
  }

  if (productJson.options[0] !== 'Title') {
    const colorOptionIndex = productJson.options.findIndex((option) => option === 'Color')
    const sizeOptionIndex = productJson.options.findIndex((option) => option === 'Size')
    const amountOptionIndex = productJson.options.findIndex((option) => option === 'Amount')

    if (colorOptionIndex > -1) {
      detail.color = variant.options[colorOptionIndex]
    }

    if (sizeOptionIndex > -1) {
      detail.size = variant.options[sizeOptionIndex]
    }

    if (amountOptionIndex > -1) {
      detail.amount = variant.options[amountOptionIndex]
    }
  }

  const bisTriggerEvent = new CustomEvent('bistrigger', { detail })
  document.dispatchEvent(bisTriggerEvent)
}

const productFormSubmit = (instance) => {
  const { dom } = instance
  const triggerWaitlist = dom.$submitBtn.dataset.triggerWaitlist === 'true'
  const {
    preOrderDate,
    madeToOrderDate,
    notEligible,
    finalSale,
  } = dom.$submitBtn.dataset
  const { productId } = dom.$component.dataset
  const variantId = parseInt(dom.$variantIdInput.value)
  const properties = {}

  const propertiesList = {
    Preorder: preOrderDate,
    'Made To Order': madeToOrderDate,
    'Not-eligible': notEligible,
    'Final Sale': finalSale,
  }

  const promoTag = getPromoTag()

  if (promoTag) {
    // eslint-disable-next-line
    propertiesList._promo_badge = promoTag
  }

  Object.keys(propertiesList).forEach((key) => {
    const value = propertiesList[key]
    if (value) {
      properties[key] = value
    }
  })

  if (triggerWaitlist) {
    triggerBis(variantId)
  } else {
    addProduct(productId, variantId, 1, properties)
  }
}

productInfoInit()

document.addEventListener('colorchange', () => {
  productInfoInit()
})

export {
  variantChange,
  colorChange,
  productFormSubmit,
  triggerBis,
}
